// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".password-gate[data-v-56c67c7a]{display:flex;flex-direction:column;gap:1rem;width:100%}.password-gate[data-v-56c67c7a],.password-gate__error[data-v-56c67c7a]{height:auto;max-height:100%;max-width:100%;position:relative}.password-gate__error[data-v-56c67c7a]{color:var(--main-accent-color);display:block;font-size:.875rem;margin:0;width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
